<template>
  <UnSwitcherNew
    :hasOpener="false"
    swKey="sw_range_height"
    tstPrefix="range_height"
  >
    <template #[slotName]="v">
      <div class="bt-grey my-1"></div>
      <GwBtns
        :options="options"
        :value="l_tab"
        idKey="payload"
        class="gwbtns_vertical_primary"
        style="--gwbtns-padding: 0"
        @click="handleClick"
      >
        <template #default="{ item }">
          <i
            class="mdi mr-2"
            :class="item.icon"
          ></i>
          {{ $t(`switchers.${item.payload}`) }}
          <UnSwitcherNew
            v-if="item.payload === 'swv_combos_horizontal'"
            class="ml-1"
            placement="bottom"
            :isInside="true"
            :hasOpener="false"
            swKey="sw_combos_chart_style"
            style="--uns-opener-clr-back: rgba(255, 255, 255, 0.075)"
          />
        </template>
        <template #after>
          <div class="bt-grey my-1"></div>
          <div
            class="gw_btn gw_btn_text z-index_0 gw_btn_small clr-grey text-small f-justify-start bt-grey"
            style="--padding: 0.5rem"
            @click="
              v.methods.toggleOpen(false),
                $store.dispatch('router_set_dialogs', 'study-graph-switcher-help-dialog')
            "
          >
            <i class="mdi mdi-help-circle-outline mr-1 text-medium" />
            {{ $t('common.help') }}
          </div>
        </template>
      </GwBtns>
    </template>
  </UnSwitcherNew>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'
import { allSwitchers } from '@/store/switchers/switchers'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyRangeHeightSwitcher',
  components: {
    UnSwitcherNew,
    GwBtns,
  },
  props: {
    hasVerticalHorizontal: { type: Boolean, default: true },
  },
  data() {
    this.options = allSwitchers().sw_combos_columns
    return {}
  },
  methods: {
    handleClick(_e, item) {
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_combos_columns',
        item,
      })
    },
  },
  computed: {
    l_tab() {
      return this.$store.getters.sw_combos_columns
    },
    slotName() {
      return this.hasVerticalHorizontal ? 'menu_after' : 'none'
    },
  },
}
</script>

<style></style>
